import React from 'react'
import { Grid, Checkbox } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';
import { dispatch } from '@rematch/core';
import { source } from 'react-aim';
import { toastr } from 'react-redux-toastr';
import diamond from '../../../../../images/grafix-icon/diamond.svg'
import Labels from './../../../../common/Labels'
import { connect } from 'react-redux';
import EditText from '../../../../common/EditText';
import EditDuration from '../../../../common/EditDuration'
import { durationValidation, singleLineText } from '../../../../common/RegexValidation';
import SingleLineEditText from '../../../../common/SingleLineEditText';
import MultiLineEditText from '../../../../common/MultiLineEditText';
let Milestone = false;
let intiativeObjToUpdate = {};
let actObj = {}
@source({
    mouseEnter: (props, component) => dispatch.app.setHelpContext(props.name)
})
class CommunityActivityResourcePaneForm extends React.Component {
    constructor(props) {
        super(props);
        this.updateActivityData = this.updateActivityData.bind(this);
        this.setMilestone = this.setMilestone.bind(this);
        this.keyPress = this.keyPress.bind(this);
    }



    updateActivityData(e) {

        intiativeObjToUpdate.initiativeid = this.props.initiativeId;
        if (e.target.name === 'duration') {
            if (/^([0-9]{0,3})$/.test(e.target.value)) {
                this.props.selectedActivityData.duration = e.target.value;
                intiativeObjToUpdate.duration = e.target.value;
                dispatch.initiatives.updateInitiativeActivities(this.props.selectedActivityData);
                dispatch.initiatives.isDurationSet(true);
            }
            else if (!(e.target.value)) {
                this.props.selectedActivityData.duration = null;
                intiativeObjToUpdate.duration = null;
                dispatch.initiatives.updateInitiativeActivities(this.props.selectedActivityData)
            }
        }
    }

    setMilestone(data) {
        if (data) {
            Milestone = !Milestone;
            this.props.selectedActivityData.isMilestone = Milestone;
            intiativeObjToUpdate.isMilestone = Milestone;
            dispatch.initiatives.updateInitiativeActivityDuration(this.props.selectedActivityData)
            this.forceUpdate();
        }
    }


    keyPress(e) {
        intiativeObjToUpdate.initiativeid = this.props.initiativeId;
        if (e.keyCode === 13 || e.keyCode === 9 || e.keyCode === 27) {
            if (e.target.name === 'duration') {
                if (/^([0-9]{0,3})$/.test(e.target.value)) {
                    this.props.selectedActivityData.duration = e.target.value;
                    intiativeObjToUpdate.duration = e.target.value;
                    dispatch.initiatives.updateInitiativeActivities(this.props.selectedActivityData)
                }
                else if (!(e.target.value)) {
                    this.props.selectedActivityData.duration = null;
                    intiativeObjToUpdate.duration = null;
                    dispatch.initiatives.updateInitiativeActivities(this.props.selectedActivityData)
                }
            }
        }
    }

    componentWillMount() {
        actObj = Object.assign({}, this.props.selectedPracticeFlowActivity);
    }

    saveData = (data) => {
        if (data.name === 'Name') {
            this.props.selectedActivityData.name = data.text;
            if ((singleLineText.test(data.text))) {
                dispatch.initiatives.updateInitiativeActivities(this.props.selectedActivityData)
            }
            else {
                this.props.selectedActivityData.name = actObj.name;
            }
        } else if (data.name === 'Description') {
            this.props.selectedActivityData.description = data.text;
            dispatch.initiatives.updateInitiativeActivities(this.props.selectedActivityData)
        }
        else if (data.name === 'Duration') {
            this.props.selectedActivityData.duration = data.text;
            dispatch.initiatives.updateInitiativeActivityDuration(this.props.selectedActivityData)
        }
    }

    componentWillReceiveProps() {
        intiativeObjToUpdate.id = this.props.selectedActivityData._id;

        intiativeObjToUpdate.initiativeid = this.props.initiativeId;
        Milestone = this.props.selectedActivityData ? this.props.selectedActivityData.isMilestone : false;
    }
    saveDuration = (data) => {
        data = data.text.toString();
        data = data.replace(/^0+/, '');
        if (/^((?!(0))[0-9]{1,3})$/.test(data)) {
            this.props.selectedActivityData.duration = data;
            dispatch.initiatives.updateInitiativeActivityDuration(this.props.selectedActivityData)
        }
        else if (!(data)) {
            this.props.selectedActivityData.duration = null;
            dispatch.initiatives.updateInitiativeActivityDuration(this.props.selectedActivityData)
        }

    }

    render() {

        Milestone = this.props.selectedActivityData ? this.props.selectedActivityData.isMilestone : false;
        const errorLabel = <div className="customErrorLabel" />;
        let activityData = this.props.selectedActivityData;
        let initiativeData;
        if (this.props.activeTab === 'myactivities') {
            initiativeData = this.props.selectedActivityData.initiativeId;
        } else {
            initiativeData = this.props.selectedDataById;
        }

        return (
            <Form noValidate
                className="formcyForm"
                ref={ref => this.form = ref}
                onValidSubmit={this.props.onSubmit}
            >
                <Grid >
                    <Grid.Row>
                        <Grid.Column width={16}>
                            {initiativeData.status === 3 || this.props.activeTab === "myactivities" ?
                                <Labels
                                    name="Name"
                                    text={activityData && activityData.name} />
                                :

                                <SingleLineEditText
                                    name="Name"
                                    text={activityData.name || ''}
                                    type="text"
                                    onSaveClick={this.saveData}
                                />

                            }
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            {initiativeData.status === 3 || this.props.activeTab === "myactivities" ?
                                <Labels
                                    name="Description"
                                    text={activityData && activityData.description}
                                    htmlView={true} />
                                :
                                <MultiLineEditText
                                    name="Description"
                                    text={activityData && activityData.description}
                                    type="textarea"
                                    onSaveClick={this.saveData}
                                    htmlView={true}
                                />


                            }
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row style={{ margin: '10px 0 0 0' }}>

                        {activityData && activityData.activities && activityData.activities.length == 0 && activityData.isLeafNode && activityData.runStatus !== 2 && (initiativeData.status === 0 || initiativeData.status === 4) ?
                            <Grid.Column width={8}>
                                {/* <EditDuration
                                    name="Duration (In Days)"
                                    text={this.props.selectedActivityData.duration ? this.props.selectedActivityData.duration : 0}
                                    id="duration"
                                    saveDuration={this.saveDuration}
                                    htmlView={true}
                                /> */}
                                <SingleLineEditText
                                    name="Duration (In Days)"
                                    text={this.props.selectedActivityData.duration ? this.props.selectedActivityData.duration : 0}
                                    type="text"
                                    id="duration"
                                    valueType="duration"
                                    onSaveClick={this.saveDuration}
                                />
                            </Grid.Column>
                            :
                            // initiativeData.status === 3 || this.props.resourcePaneFlag !== "ConfigureActivities" || activityData.runStatus === 2 ?
                            (activityData && activityData.activities && activityData.activities.length > 0) || (activityData && activityData.isParentNode) ? '' :
                                <Labels
                                    name="Duration (In Days)"
                                    text={this.props.selectedActivityData.duration} />
                            // : ''
                        }
                        {activityData && activityData.activities && activityData.activities.length == 0 && activityData.isLeafNode ?
                            <Grid.Column width={activityData && activityData.activities && activityData.activities.length > 0 ? 16 : 8} >
                                <div style={{ float: 'right' }}><br />
                                    {
                                        this.props.resourcePaneFlag === "ConfigureActivities" && activityData.runStatus !== 2 ?
                                            <span>
                                                <img src={diamond} name="diamond" style={{ 'height': '12px' }} alt='' />&nbsp;
                                                <span>Milestone Activity</span>
                                                <Checkbox className='diamond-location'

                                                    checked={activityData ? activityData.isMilestone : Milestone}
                                                    onChange={this.setMilestone} />
                                            </span> : activityData.isMilestone ?
                                                <span>
                                                    <img src={diamond} name="diamond" style={{ 'height': '12px' }} alt='' />&nbsp;
                                                    This is a Milestone Activity
                                            </span> : ""
                                    }
                                </div>
                            </Grid.Column> : ''}
                    </Grid.Row>
                </Grid>
            </Form>
        )
    }
}

function mapStateToProps(state) {
    return {
        resourcePaneFlag: state.initiatives.resourcePaneFlag,
        initiativeId: state.initiatives.initiativeId
    };
}

const connectedCommunityActivityResourcePaneForm = connect(mapStateToProps)(CommunityActivityResourcePaneForm);

export default connectedCommunityActivityResourcePaneForm;